// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PARCEIRO_VND_PAPEL_COM = {
  SDRPreVendas: 'PARCEIRO_VND_PAPEL_COM1',
  VendedorInternoInsideSalesCloser: 'PARCEIRO_VND_PAPEL_COM2',
  RepresentanteExternoRCA: 'PARCEIRO_VND_PAPEL_COM3',
  KeyAccountManagerKAM: 'PARCEIRO_VND_PAPEL_COM4',
  GestorComercial: 'PARCEIRO_VND_PAPEL_COM5',
  Broker: 'PARCEIRO_VND_PAPEL_COM6',
  BackofficeComercial: 'PARCEIRO_VND_PAPEL_COM7',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PARCEIRO_VND_PAPEL_COM1: 1,
    PARCEIRO_VND_PAPEL_COM2: 2,
    PARCEIRO_VND_PAPEL_COM3: 3,
    PARCEIRO_VND_PAPEL_COM4: 4,
    PARCEIRO_VND_PAPEL_COM5: 5,
    PARCEIRO_VND_PAPEL_COM6: 6,
    PARCEIRO_VND_PAPEL_COM7: 7
  }
}
